<div *ngIf="isAuthorized == true">
<app-header-rapport-miramas (EventValueDate)="getDate($event)" (newItemEventCamera)="addCamera($event)"
                    (newItemEventProblem)="addProbleme($event)" (EventChecked)="getCheckedValue($event)" >

</app-header-rapport-miramas>

<app-display-compteur-miramas (allTickets)="getTickets($event)" [camera]="cameraForDisplay" [panne]="probleme"
                      [dateForChart]="dateForChart" [getAllTicketsForMomentTab]="getAllTicketsForMomentTab" [checkedValue]="checkedValue">

</app-display-compteur-miramas>

<app-display-rapports-miramas [inputTickets]="inputTickets" [date]="date" [camera]="cameraForDisplay"
                      [panne]="probleme" (sendTableTickets)="getAllTicketsForMoment($event)"
                      (senddateForChart)="getDateValue($event)" [checkedValue]="checkedValue">

</app-display-rapports-miramas>
</div>
